<template>
	<div class="h-full">
		<TopAppBar
			:title="title"
      :hideCategory="false"
		>
		</TopAppBar>
		<div class="d-flex h-full flex-column">
			<TopAppBarDrawer></TopAppBarDrawer>
			<router-view></router-view>
			<!-- <degree-list></degree-list> -->
		</div>
	</div>
</template>

<script>
/**
 * 전체 차수 메인 컴포넌트degree main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import {topAppBarMixin} from '../mixins/topAppBar.js'

export default {
	name: 'degree',

	data() {
		return {
			title: localStorage.getItem('brandName')
		}
	},

	components: {
		TopAppBar,
		TopAppBarDrawer
	},

	mixins: [topAppBarMixin],

	mounted() {
		let backTo = localStorage.getItem("portfolio", "backtoPortfolio");
		if(backTo !== 'backtoPortfolio'){
			this.setTopAppBarHomeSearch(localStorage.getItem('brandName'))
		} else {
			localStorage.removeItem("portfolio");
			this.setTopAppBarBackPortfolio(localStorage.getItem('brandName'))
		}
	}
}
</script>
